import React from "react";
import SearchDropdown from "./SearchDropdown";

const MobileSearchPanel = ({
  searchQuery,
  onSearchQueryChange,
  selectedSearchBrand,
  onSelectedSearchBrandChange,
  onSearchInputKeyDown,
  onSearchSubmit,
}) => {
  return (
    <div className="tablet:hidden w-full flex flex-col gap-2">
      <input
        type="text"
        placeholder="What are you looking for?"
        value={searchQuery}
        onChange={(event) => onSearchQueryChange(event.target.value)}
        onKeyDown={onSearchInputKeyDown}
        className="w-full focus:shadow-none focus:border-white h-[44px] px-4 rounded-[8px] bg-white text-_1424 font-work-sans font-normal placeholder-mqgrey3"
      />

      <div className="w-full">
        <SearchDropdown
          value={selectedSearchBrand}
          onChange={onSelectedSearchBrandChange}
        />
      </div>

      <button
        type="button"
        onClick={onSearchSubmit}
        className="w-full px-5 py-2 bg-mqgrey4 text-white text-_1424 font-work-sans font-medium rounded-[8px] hover:bg-mqgrey5 transition-colors"
      >
        Search
      </button>
    </div>
  );
};

export default MobileSearchPanel;
